import {carrerasApi} from "../../view/carreras.service";

export const getNivelesDeEstudio = carrerasApi.injectEndpoints({
  endpoints: (builder) => ({
    getNivelesDeEstudios: builder.query({
      query: () => ({
        url: `/v1/api/niveldeestudios/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "Niveles", id}],
    }),
  })
})

export const {
  useGetNivelesDeEstudiosQuery,
} = getNivelesDeEstudio;